module.exports = __webpack_public_path__ + "static/img/1.a788c1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/1.png
// module id = P/as
// module chunks = 0